import { useQueueContentChatContext } from './useQueueContentChat';
import { useSocketConversationChatTs } from './useSocketConversationChatTs';

export const hooks = {
  useQueueContentChatContext,
  useSocketConversationChatTs
};
